import React from 'react';
import {Box, Divider, Flex, Image, Text} from "@chakra-ui/react";
import './MapLegend.css';

const MapLegend = (props) => {

    return (
        <Flex className={"map_container"}>
            {(props?.isAdded || props?.isTemp || props?.isCurrent) && <Text fontWeight={"bold"}>LEGENDA</Text>}
            <br/>
            {
                props?.isAdded &&
                <Flex flexDirection={"row"} gap={"10px"} alignItems={"center"}>
                    <Image boxSize='40px' src='/GPS_SAVED.png' fallbackSrc='https://via.placeholder.com/150' />
                    <Text>Punti caricati sul Database</Text>
                </Flex>
            }
            {
                props?.isTemp &&
                <Flex flexDirection={"row"} gap={"10px"} alignItems={"center"}>
                    <Image boxSize='40px' src='/GPS_TEMP.png' fallbackSrc='https://via.placeholder.com/150' />
                    <Text>Punti in attesa verso il Database</Text>
                </Flex>
            }
            {
                props?.isCurrent &&
                <Flex flexDirection={"row"} gap={"10px"} alignItems={"center"}>
                    <Image boxSize='40px' src='/GPS_TO_ADD.png' fallbackSrc='https://via.placeholder.com/150' />
                    <Text>{`Il punto di interesse che stai modificando`}</Text>
                </Flex>
            }
        </Flex>
    );
};

export default MapLegend;
